import { Component, computed, DestroyRef, inject, signal, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { AppHeaderComponent, DarkModeToggleComponent } from 'ok-angular-shared/components';
import { EnvironmentLoaderService } from 'ok-angular-shared/services';
import { AppSettings } from 'src/settings/appsettings.interface';

@Component({
  selector: 'app-page-minimum',
  templateUrl: './page-minimum.component.html',
  styleUrls: ['./page-minimum.component.scss'],
  imports: [RouterOutlet, AppHeaderComponent, DarkModeToggleComponent],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'page' },
})
export class PageMinimumComponent {
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);
  private environmentLoaderService = inject<EnvironmentLoaderService<AppSettings>>(EnvironmentLoaderService);

  public disableOkLink = signal(false);
  public version = computed(() => this.environmentLoaderService.buildData().version);

  constructor() {
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      this.disableOkLink.set(data.disableOkLink);
    });
  }
}
